// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5bc04bca","952":"bba22bc4"}[chunkId] + ".chunk.js";
};